import { useState, useEffect } from 'react';
import { vehicleAPI } from '../services/api';

export const useVehicles = (filters = {}) => {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchVehicles = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await vehicleAPI.getVehicles(filters);
      setVehicles(data);
    } catch (err) {
      console.error('Error fetching vehicles:', err);
      setError(err.response?.data?.detail || 'Failed to fetch vehicles');
      // Fallback to empty array on error
      setVehicles([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVehicles();
  }, [JSON.stringify(filters)]);

  const refetch = () => {
    fetchVehicles();
  };

  return {
    vehicles,
    loading,
    error,
    refetch
  };
};

export const useVehicle = (id) => {
  const [vehicle, setVehicle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchVehicle = async () => {
      if (!id) return;
      
      try {
        setLoading(true);
        setError(null);
        const data = await vehicleAPI.getVehicleById(id);
        setVehicle(data);
      } catch (err) {
        console.error('Error fetching vehicle:', err);
        setError(err.response?.data?.detail || 'Failed to fetch vehicle');
        setVehicle(null);
      } finally {
        setLoading(false);
      }
    };

    fetchVehicle();
  }, [id]);

  return {
    vehicle,
    loading,
    error
  };
};